import React from 'react';

import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, Breadcrumbs, Chip, Container, Stack, Typography } from '@mui/material';
import { Link, navigate } from 'gatsby';
import styled from 'styled-components';

import ImageFluid from '../../legacy/components/base/ImageFluid';
import RawHtml from '../../legacy/components/base/RawHtml';
import Styles from '../../legacy/components/base/ExperiencePost/ExperiencePost.styles';
import { getKey } from '../../legacy/helpers';
import { Tag } from './type';

// Legacy styled-components
const Content = styled.div`
  ${Styles.content}
`;

// ********************************************************************************
type Props = {
  backtext: string;
  title: string;
  review: string;
  content: string;
  image: any;
  tags: Tag[];
  locale: string;
  date: string;
};
export const ExperienceArticle: React.FC<Props> = (props) => {
  return (
    <Stack spacing={2} sx={{ pt: 4 }} alignItems="center" width="100%" bgcolor="#F3F2F5">
      <Container maxWidth="lg">
        <Stack spacing={2}>
          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="medium" sx={{ color: '#6C6D70' }} />}
            aria-label="breadcrumb"
          >
            <Link to="/experience">
              <Box display="flex" alignItems="center" gap={1}>
                <ArrowBackIcon sx={{ color: 'black' }} fontSize="small" />
                <Typography color="secondary.contrastText">Blog</Typography>
              </Box>
            </Link>
            <Typography color="primary" fontFamily="Gotham-Medium">
              {props.title}
            </Typography>
          </Breadcrumbs>
          <Box height="368px" borderRadius="12px" overflow="hidden">
            <ImageFluid fluid={props.image} />
          </Box>

          <Stack spacing={1} py={2}>
            <Box display="flex" gap={1}>
              {props.tags.map((tag) => (
                <Chip
                  key={tag.id}
                  label={getKey(tag, `title_${props.locale}`) ?? ''}
                  variant="filled"
                  color="primary"
                  size="small"
                  onClick={() => navigate(`/experience${tag.slug}`)}
                />
              ))}
            </Box>
            <Typography variant="h1" color="#2D2F31" fontSize="24px">
              {props.title}
            </Typography>
            <Typography variant="subtitle1" color="#2D2F31" fontSize="16px" fontFamily="Gotham-Light">
              {props.review}
            </Typography>
          </Stack>
        </Stack>
      </Container>
      <Box width="100%" bgcolor="white" py="3rem">
        <Container maxWidth="lg">
          <Content>
            <RawHtml content={props.content} />
          </Content>
        </Container>
      </Box>
    </Stack>
  );
};
